<template>
  <div class='settings-layout'>
    <div class="settings-layout__header">
      <div class="settings-layout__header__title">
        {{$t('tenant.settings.title')}}
      </div>
    </div>
    <el-tabs class='tabs-section' v-model="activeName" @tab-click="handleClick">
      <el-tab-pane v-if="!isLicenseExpired" :label="$t('settings.tab.label.tenant.management').toString()" name="user_management">
        <user-management/>
      </el-tab-pane>
      <el-tab-pane v-if="!isLicenseExpired" :label="$t('settings.tab.label.organizations.settings').toString()" name='organizations-settings'>
        <organizations-settings/>
      </el-tab-pane>
      <el-tab-pane v-if="!isLicenseExpired" :label="$t('settings.tab.label.automated.remediation.settings').toString()" name='automated-remediation-settings'>
        <automated-remediation-settings/>
      </el-tab-pane>
      <el-tab-pane v-if="!isLicenseExpired" :label="$t('settings.tab.label.brand.protection.settings').toString()" name='brand-protection-settings'>
        <brand-protection-settings/>
      </el-tab-pane>
      <el-tab-pane :label="$t('settings.tab.label.licensing').toString()" name='licensing-settings'>
        <licensing-settings/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import UserManagement from '@/views/UserManagement.vue';
import AutomatedRemediationSettings from '@/components/Settings/AutomatedRemediationSettings.vue';
import BrandProtectionSettings from '@/components/Settings/BrandProtectionSettings.vue';
import LicensingSettings from '@/components/Settings/LicensingSettings.vue';
import OrganizationsSettings from '@/components/Settings/OrganizationsSettings.vue';
import { LOAD_ALL_ORGANIZATIONS } from '@/store/organization/actionTypes';
import {
  LOAD_COMPANY_CUSTOMER_FULL_INDUSTRIES_OPTIONS,
  LOAD_COMPANY_CUSTOMER_FULL_REGIONS_OPTIONS,
  LOAD_COMPANY_CUSTOMER_FULL_REGULATIONS_OPTIONS, LOAD_DOMAINS,
} from '@/store/user/actionTypes';
import { LOAD_AMOUNT_OF_EMPLOYEES, LOAD_CYBERSECURITY_KNOWHOW_OPTIONS } from '@/store/registration/actionTypes';
import {
  CHANGE_CLOUD_ACCOUNTS_LIST_OPTIONS,
  LOAD_DOMAINS_FROM_CONFIGURATION,
  LOAD_ORGANIZATION_TAGS_FROM_CONFIGURATION,
} from '@/store/project/actionTypes';

export default {
  name: 'SettingsLayout',
  components: {
    OrganizationsSettings,
    AutomatedRemediationSettings,
    BrandProtectionSettings,
    LicensingSettings,
    UserManagement,
  },
  async mounted() {
    // When license is expired, force the licensing tab
    if (this.isLicenseExpired) {
      this.activeName = 'licensing-settings';
    } else {
      switch (this.$route.hash) {
      case '#user_management':
        this.activeName = 'user_management';
        break;
      case '#automated-remediation-settings':
        this.activeName = 'automated-remediation-settings';
        break;
      case '#brand-protection-settings':
        this.activeName = 'brand-protection-settings';
        break;
      case '#organizations-settings':
        this.activeName = 'organizations-settings';
        break;
      case '#licensing-settings':
        this.activeName = 'licensing-settings';
        break;
      default:
        break;
      }
    }
    await this.$store.dispatch(LOAD_ALL_ORGANIZATIONS);
    await this.$store.dispatch(LOAD_ORGANIZATION_TAGS_FROM_CONFIGURATION);
    await this.$store.dispatch(LOAD_DOMAINS);
    await this.$store.dispatch(CHANGE_CLOUD_ACCOUNTS_LIST_OPTIONS, {
      noLimit: true,
    });
    await this.$store.dispatch(LOAD_DOMAINS_FROM_CONFIGURATION);
    await this.$store.dispatch(LOAD_COMPANY_CUSTOMER_FULL_REGIONS_OPTIONS);
    await this.$store.dispatch(LOAD_COMPANY_CUSTOMER_FULL_REGULATIONS_OPTIONS);
    await this.$store.dispatch(LOAD_COMPANY_CUSTOMER_FULL_INDUSTRIES_OPTIONS);
    await this.$store.dispatch(LOAD_AMOUNT_OF_EMPLOYEES);
    await this.$store.dispatch(LOAD_CYBERSECURITY_KNOWHOW_OPTIONS);
  },
  data() {
    return {
      activeName: 'user_management',
      currentName: 'user_management',
    };
  },
  computed: {
    ...mapGetters(['isLicenseExpired']),
  },
  watch: {
    isLicenseExpired(expired) {
      if (expired) {
        this.activeName = 'licensing-settings';
      }
    },
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    handleClick(tab, event) {
    },
  },
};
</script>

<style lang='scss' scoped>
@import "~@/assets/styles/design-system";

.settings-layout {
  padding-top: $space-9;

  &__header {
    padding-bottom: $space-9;
    padding-left: $space-9;

    &__title {
      color: var(--text-primary);
      font-family: $font-family-bold;
      font-size: $font-size-2xl;
      font-weight: bold;
      line-height: $line-height-tight;
      letter-spacing: $letter-spacing-normal;
      margin-bottom: $space-5;
    }
  }
}
</style>

<style lang='scss'>
@import "~@/assets/styles/design-system";

.settings-layout {
  .el-tabs.el-tabs {
    .el-tabs__item {
      color: var(--text-secondary);

      &.is-active {
        color: var(--text-secondary);
      }
    }

    .el-tabs__active-bar {
      background-color: #2459D5;
    }
  }
}
</style>
